import React from "react";

const HiddenRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 32,
  height: 32,
  x: 0,
  y: 0,
  viewBox: "0 0 32 32",
  xmlSpace: "preserve",
  className: "transform-gpu " + (props.className || ""),
  ref: svgRef
}, props), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M24.687 23.273c2.404-1.692 4.274-4.086 5.259-6.948.072-.21.072-.44 0-.65C27.954 9.888 22.35 6 16 6c-2.479 0-4.84.599-6.92 1.665L3.707 2.293a.999.999 0 1 0-1.414 1.414l5.02 5.02c-2.404 1.692-4.274 4.086-5.259 6.948-.072.21-.072.44 0 .65 2.882 8.374 12.886 12.099 20.866 8.009l5.372 5.372a.999.999 0 1 0 1.414-1.414zM16 8c5.376 0 10.128 3.2 11.937 8-.913 2.421-2.575 4.433-4.688 5.835l-2.364-2.364A5.961 5.961 0 0 0 22 16c0-3.309-2.691-6-6-6-1.294 0-2.49.416-3.471 1.115l-1.952-1.952A13.188 13.188 0 0 1 16 8zm-3.433 5.981 5.452 5.452A3.947 3.947 0 0 1 16 20c-2.206 0-4-1.794-4-4 0-.74.215-1.424.567-2.019zm1.414-1.414A3.947 3.947 0 0 1 16 12c2.206 0 4 1.794 4 4 0 .74-.215 1.424-.567 2.019zM4.063 16c.913-2.421 2.575-4.433 4.688-5.835l2.364 2.364A5.961 5.961 0 0 0 10 16c0 3.309 2.691 6 6 6 1.294 0 2.49-.416 3.471-1.115l1.952 1.952C14.685 25.871 6.611 22.762 4.063 16z",
  fill: "currentColor",
  opacity: 1,
  "data-original": "currentColor"
})));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(HiddenRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;